import { AuthProvider, EventsProvider, ServicesProvider } from "../../contexts";
import { NetworkProvider } from "../../contexts/network";
import { MailvistaSDKProps } from "./types/mailvistaSdk";

export function MailvistaSDK({
    children,
    apiBackendTarget,
    clientInfo,
    readUserTimezone,
    conversationContract,
}: Readonly<MailvistaSDKProps>) {
    console.log(`MailvistaSDK() - apiBackendTarget : ${apiBackendTarget}`);
    console.log(`==============================================`);

    return (
        <EventsProvider>
            <NetworkProvider>
                <AuthProvider>
                    <ServicesProvider
                        apiTarget_v2={apiBackendTarget}
                        clientInfo={clientInfo}
                        readUserTimezone={readUserTimezone}
                        conversationContract={conversationContract}
                    >
                        {children}
                    </ServicesProvider>
                </AuthProvider>
            </NetworkProvider>
        </EventsProvider>
    );
}
